import { BaseFieldComponent } from '../base-field/base-field.component';
import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'forms-bool',
  templateUrl: './bool.component.html',
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BoolComponent),
      multi: true,
    },
  ],
})
export class BoolComponent extends BaseFieldComponent {}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/bool/bool.component.ts